"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _oxygenConstants = require("@8x8/oxygen-constants");

var getMaxWidth = function getMaxWidth(_ref) {
  var size = _ref.size;
  return "\n  width: ".concat(_oxygenConstants.toastSizeToWidthMap[size], ";\n  max-width: 100%;  \n");
};

var _default = getMaxWidth;
exports["default"] = _default;